import { EntrySkeletonType } from 'contentful';
import type { Document } from '@contentful/rich-text-types';
import { ArticleFeaturedImage } from '../../types/common/Article.types';
import type { MarkdownArticleFeaturedImage } from '../../lib/articles';

export enum Preview {
    VERTICAL = 'vertical',
    HORIZONTAL = 'horizontal',
}

export interface ArticlePreviewProps {
    title: string;
    excerpt?: Document;
    slug: string;
    createdDate: Date;
    featuredImage?: EntrySkeletonType<ArticleFeaturedImage> | MarkdownArticleFeaturedImage;
    className?: string;
    preview: Preview;
    externalSource?: string;
    showContentType?: boolean;
}
